module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      操作保护\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group-list domain-list"
  }, [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('div', {
    staticClass: "form-group-item"
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("\n\t\t\t\t\t\t验证图片\n\t\t\t\t\t")]), _vm._v(" "), _c('img', {
    staticClass: "error-img",
    attrs: {
      "src": _vm.captcha,
      "title": "点击更换"
    },
    on: {
      "click": _vm.changeYzm
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group-item"
  }, [_c('x-input', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "label-width": "7.5em",
      "title": "验证码",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.yzm),
      callback: function($$v) {
        _vm.yzm = $$v
      },
      expression: "yzm"
    }
  })], 1)])]), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": ".2rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确定")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("您正在执行关键操作，为了您的账户资产安全，请您进行二次验证。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5683e162","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/hostoperate/clearnet.vue
// module id = Galk
// module chunks = 1